import { baseThunk } from '../../fetch/basicThunk';
import { QUERY_GET_TAXONOMY_TEMPLATES } from '../../fetch/constantQueries';

export const getTaxonomyTemplates = baseThunk("getTaxonomyTemplates/getTaxonomyTemplates", QUERY_GET_TAXONOMY_TEMPLATES, "GET")